// extracted by mini-css-extract-plugin
module.exports = {"button":"primitives_button__3bgg4","primary":"primitives_primary__lihou","outline":"primitives_outline__tWy0a","ghost":"primitives_ghost___djd3","card":"primitives_card__KlGU9"};